import { module } from "angular";
import type { Duration } from "moment-timezone";

import humanizeDuration from "humanize-duration";

import type { IHumanizeDurationService } from "./IHumanizeDurationService";

export class HumanizeDurationService implements IHumanizeDurationService {
    public humanize(momentDuration: Duration, lang = "en"): string {
        return humanizeDuration(momentDuration.asMilliseconds(), {
            language: lang,
            round: true,
            units: ["d", "h", "m"],
        });
    }
}

module("mmServices").service("irHumanizeDurationService", HumanizeDurationService);
